import { useCallback, useMemo, useSyncExternalStore } from "react";

// Chakra's default breakpoints, which the theme does not override.
export const BREAKPOINTS = {
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em",
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

export const useMediaQuery = (query: string): boolean => {
  const mediaQueryList = useMemo(() => window.matchMedia(query), [query]);

  const subscribe = useCallback(
    (onChange: () => void) => {
      mediaQueryList.addEventListener("change", onChange);
      return () => mediaQueryList.removeEventListener("change", onChange);
    },
    [mediaQueryList],
  );

  return useSyncExternalStore(subscribe, () => mediaQueryList.matches);
};
